import requestInstance from '../../utils/instance-utils';

export const checkReferentialWhitelist = (ecrId: string) =>
    requestInstance.post('/client/referential-whitelist-check', {
        ecrId,
    });
